import { render } from "./DashboardLayout.vue?vue&type=template&id=68ad9a9c&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=68ad9a9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ad9a9c"]])

export default __exports__